import constVars from '~/constants/constVars';
import React, { ReactElement } from 'react';
import {
  withAuthenticationRequired,
  WithAuthenticationRequiredOptions,
} from '@auth0/auth0-react';
import { Route, RouteProps } from 'react-router';
import Spinner from '~/components/shared/Spinner/SpinnerCircular';
import { theme } from './styles/themes';

const ProtectedRoute = ({ ...props }: RouteProps): ReactElement => {
  return <Route {...props} />;
};

let options: WithAuthenticationRequiredOptions = {
  onRedirecting: () => {
    if (window.location.pathname !== constVars.ROUTE_DEFAULT) {
      sessionStorage.setItem(
        'returnTo',
        `${window.location.pathname}${window.location.search}`
      );
    }

    return <Spinner color={theme.colors.secondaryGray} />;
  },
  loginOptions: {
    authorizationParams: {
      redirectUri: `${window.location.origin}/${constVars.ROUTE_LOGIN}`,
      prompt: 'none',
    },
  },
};

if (import.meta.env.MODE === 'internal-prod') {
  options = {};
}

export default withAuthenticationRequired(ProtectedRoute, options);
